export default __webpack_public_path__ + "static/media/chat_ico.6a0c17f9.svg";